import { Fragment, memo, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { QueryDropdown } from 'basic-components';
import { Clear, Filter, FilterSelected } from 'basic-components/icons';
import Query from 'dashboard-services/api/Query';

import getApiConfig from 'api/ApiConfig';
import { pipelinesQueries } from 'queries/modules/datascience';

import { Else, If, Then, When } from 'react-if';

import './TagFilter.scss';

const EMPTY_ARRAY = [];
const TagFilter = ({ tag = undefined, setTag }) => {
  const dispatch = useDispatch(),
        [isOpen, setIsOpen] = useState(false),
        openAdaptive = useCallback(() => setIsOpen(isOpenLoc => !isOpenLoc), []),
        clearTag = useCallback(() => setTag(undefined), [setTag]),
        [tagQuery, setTagQuery] = useState(),
        getApiConfigLocal = useCallback(() => dispatch(getApiConfig()), [dispatch]),
        getQueryBuilder = useCallback(() => 
          new Query.Builder(getApiConfigLocal())
            .withFetching(false)
        , [getApiConfigLocal]),
        { data: tags = EMPTY_ARRAY, isPending, isFetching } = pipelinesQueries.useGetPipelineTags({ getQueryBuilder, query: tagQuery }),
        changeTag = useCallback(value => {
          if(value) {
            setIsOpen(false)
          }
          setTag(value)
        }, [setTag])

  return (
    <div className="statuses__see-all__content__header__filter">
      <div className="statuses__see-all__content__header__filter__trigger">
        <If condition={tag !== undefined && tag !== null && tag !== ""}>
          <Then>
            {() => (
              <Fragment>
                <div onClick={openAdaptive}>
                  <FilterSelected 
                      color="blue-bright"
                      height={16}
                      width={16}
                  />
                </div>
                <div 
                    className="statuses__see-all__content__header__filter__trigger__clear"
                    onClick={clearTag}
                >
                  <Clear color="grey-dark"/>
                </div>
              </Fragment>
            )}
          </Then>
          <Else>
            {() => (
              <div onClick={openAdaptive}>
                <Filter 
                    color="blue-bright"
                    height={16}
                    width={16}
                />
              </div>
            )}
          </Else>
        </If>
      </div>
      <When condition={isOpen}>
        {() => (
          <div className="statuses__see-all__content__header__filter__dropdown">
            <QueryDropdown
                defaultValue={tag}
                isFetching={isPending || isFetching}
                menuPortalTarget={document.body}
                name="tag"
                onChange={changeTag}
                onInputChange={setTagQuery}
                openMenuOnFocus
                options={tags}
                placeholder="Filter by tag"
            />
          </div>
        )}
      </When>
    </div>
  )
}

TagFilter.propTypes = {
  setTag: PropTypes.func.isRequired,
  tag: PropTypes.string,
}

export default memo(TagFilter);